import 'bingmaps';
import { environment } from 'environment';

// Bingmaps package is only type definitions, implemenation is added in index.html through script reference.
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// Move map location relative to control, (0,0) being top left.
function moveMapLocation(
  map: Microsoft.Maps.Map,
  location: Microsoft.Maps.Location,
  xDelta: number,
  yDelta: number
): Microsoft.Maps.Location {
  const result = map.tryLocationToPixel(location, Microsoft.Maps.PixelReference.control) as Microsoft.Maps.Point;
  result.x += xDelta;
  result.y += yDelta;
  const alignedLocation = map.tryPixelToLocation(
    result,
    Microsoft.Maps.PixelReference.control
  ) as Microsoft.Maps.Location;
  return alignedLocation;
}

export function createBingMap(
  center: string[],
  zoom: number,
  ref: React.RefObject<HTMLDivElement>,
  label: string,
  isSmall: boolean
): void {
  // TODO: add better telemetry here
  if (!ref.current) {
    console.log('Bing map creation failed');
    return;
  }

  const itemLocation = new Microsoft.Maps.Location(center[0], center[1]);
  const map = new Microsoft.Maps.Map(ref.current, {
    credentials: environment.bingmapKey,
    center: itemLocation,
    zoom,
    showMapTypeSelector: !isSmall
  });
  const pin = new Microsoft.Maps.Pushpin(itemLocation, {
    title: label,
    text: '1'
  });
  map.entities.push(pin);

  // Keep pin 30% from the top of the map
  const movedCenter = moveMapLocation(map, itemLocation, 0, ref.current.clientHeight * 0.2);
  map.setView({
    center: movedCenter,
    zoom
  });

  Microsoft.Maps.loadModule('Microsoft.Maps.Traffic', () => {
    const manager = new Microsoft.Maps.Traffic.TrafficManager(map);
    manager.show();
    if (isSmall) manager.hideLegend();
  });
}
